import axios from 'axios'

import qs from 'qs'

import { isFunction } from '@/utils/isUtils'

// 声明一个 Map 用于存储每个请求的标识 和 取消函数
let pendingMap = new Map()

export const getPendingUrl = (config) =>
  [config.method, config.url, qs.stringify(config.data), qs.stringify(config.params)].join('&')

export class AxiosCanceler {
  /**
   * 添加请求
   * @param {Object} config
   */
  addPending(config) {
    this.removePending(config)
    const url = getPendingUrl(config)
    config.cancelToken =
      config.cancelToken ||
      new axios.CancelToken((cancel) => {
        if (!pendingMap.has(url)) {
          // 如果 pending 中不存在当前请求，则添加进去
          pendingMap.set(url, cancel)
        }
      })
    // console.log('addPending: ', url)
  }

  /**
   * 移除map内重复的请求，并执行取消请求
   * @param {Object} config
   */
  removePending(config) {
    const url = getPendingUrl(config)

    if (pendingMap.has(url)) {
      // 如果在 pending 中存在当前请求标识，需要取消当前请求，并且移除
      const cancel = pendingMap.get(url)
      // console.log('removePending: ', url)
      cancel && cancel(url)
      pendingMap.delete(url)
    }
  }

  // 重复请求取消掉，最后一个请求通过
  cancelOtherRequest(config) {
    this.removePending(config) // 取消重复的请求
    this.addPending(config) // 当前请求添加到请求pending的Map中，记录是否重复请求
  }

  /**
   * @description: 清空所有pending
   */
  removeAllPending() {
    pendingMap.forEach((cancel) => {
      cancel && isFunction(cancel) && cancel()
    })
    pendingMap.clear()
  }

  /**
   * @description: 重置
   */
  reset() {
    pendingMap = new Map()
  }
}
